import { CompanyProfile, CompanyProfileRequest, UpdateCompanyProfilePayload } from "@/shared/interfaces";
import { ISettingState } from "@/shared/interfaces/setting";
import { PayloadAction } from "@reduxjs/toolkit";

export const companyProfileActions = {
  getCompanyProfiles: (state: ISettingState) => {
    state.companyProfilesStatus = "loading";
  },
  getCompanyProfilesSuccess: (state: ISettingState, action: PayloadAction<CompanyProfile[]>) => {
    state.companyProfilesStatus = "loaded";
    state.companyProfiles = action.payload;
  },
  getCompanyProfilesFailed: (state: ISettingState) => {
    state.companyProfilesStatus = "failed";
  },
  createCompanyProfile: (state: ISettingState, _action: PayloadAction<CompanyProfileRequest>) => {
    state.loading = true;
    state.savedCompanyProfile = undefined;
  },
  createCompanyProfileSuccess: (state: ISettingState, action: PayloadAction<CompanyProfile>) => {
    state.loading = false;
    state.savedCompanyProfile = action.payload;
  },
  updateCompanyProfile: (state: ISettingState, _action: PayloadAction<UpdateCompanyProfilePayload>) => {
    state.loading = true;
    state.savedCompanyProfile = undefined;
  },
  updateCompanyProfileSuccess: (state: ISettingState, action: PayloadAction<CompanyProfile>) => {
    state.loading = false;
    state.savedCompanyProfile = action.payload;
  },
};
